import React from 'react';
import KiButton from 'components/KiButton';

export const KiIconButton = props => {
	return <KiButton iconButton {...props} />;
};

export default KiIconButton;
